import React, { useEffect, useRef, useState } from "react";
import { fetchRegionSearchVals } from "../../api/DRN/drnsearch";
import { getTaxCertificateData, getTaxcFilerDetails, getTaxNotification } from "../../api/TAX/getTax";
import { useMsal } from "@azure/msal-react";
import { RowSelectionState } from "@tanstack/react-table";
import TaxCertificateTable from "./TaxCertificateTable";
import "./TaxHome.scss";
import { Spinner, Badge, Button as DSButton } from "@bphxd/ds-core-react";
import { Download16, Info24, Info32 } from "@bphxd/ds-core-react/lib/icons";
import TaxFilter from "./TaxFilter";
import { Button } from "@bphxd/ds-core-react";
import Filter from "../Home/Filter";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
import { downloadSelectedDrn, downloadALLDocs, downloadALLTaxDocs } from "../../api/DRN/drndownload";
import PaginationControls from "./PaginationControls";

export default function TaxHome() {
  const { accounts } = useMsal();
  const token = sessionStorage.getItem("jwt");
  const role = sessionStorage.getItem("role");

  const hasFetched = useRef(false);
  const userEmail = accounts?.[0]?.username || "";
const userName = accounts?.[0]?.name || "";
  // states
  const [regionData, setRegionData] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalPendingRecords, setTotalPendingRecords] = useState<number>(0);
  const [totalvalidRecords, setTotalValidRecords] = useState<number>(0);
  const [totalInValidRecords, setTotalInValidRecords] = useState<number>(0);
  const [totalexpiredRecords, setTotalExpiredRecords] = useState<number>(0);
  const [totaloverdueRecords, setTotalOverdueRecords] = useState<number>(0);

  const [taxCertificateData, setTaxCertificateData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<RowSelectionState>({});
  const [selectedFlatRows, setSelectedFlatRows] = useState<any[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [taxFilerDetails, setTaxFilerDetails] = useState<any>(null);
  const [triggerAddModal, setTriggerAddModal] = useState<boolean>(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  // Download states
  const [downloadALLmodal, setDownloadALLmodal] = useState<boolean>(false);
  const [downloadALLAttenmodal, setDownloadALLAttenmodal] = useState<boolean>(false);
  const [currentFilterParams, setCurrentFilterParams] = useState<any>(null);

  const cards = [
    { label: "Total Orders", count: totalRecords, key: "total", color: "navy" },
    { label: "Pending Validation", count: totalPendingRecords, key: "pending", color: "orange" },
    { label: "Overdue", count: totaloverdueRecords, key: "overdue", color: "purple" },
    { label: "Validated", count: totalvalidRecords, key: "validated", color: "green" },
    { label: "Invalid", count: totalInValidRecords, key: "invalid", color: "red" },
    { label: "Expiring in 30 Days", count: totalexpiredRecords, key: "expired", color: "blue" },
  ];

  const defaultFilters = {
    region_name: [],
    status: [],
    account_manager: [],
    bussiness_channel: [],
    country_name: [],
    cust_code: [],
    cust_name: [],
    cust_sales_area: [],
    order_number: [],
    port_name: [],
    sales_country: [],
    tax_document_type: [],
    vessel_imo_number: [],
    vessel_name: [],
  };

  // ============ DOWNLOAD FUNCTIONALITY ============

  useEffect(() => {
    if (
      selectedFlatRows.length !== 0 &&
      selectedFlatRows.length === taxCertificateData.length &&
      totalRecords > 10
    ) {
      setDownloadALLmodal(true);
    }
  }, [selectedFlatRows]);

  const downloadALLtoggle = () => setDownloadALLmodal(!downloadALLmodal);
  const downloadALLAttentoggle = () => setDownloadALLAttenmodal(!downloadALLAttenmodal);

  const downloadAll = async () => {
    setIsLoading(true);
    const selectedAllRecords = selectedFlatRows.map((elem) => ({
      document_id: elem.document_id,
      document_type: "Tax Documents",
      order_number: elem.order_number,
    }));

    try {
      console.log("Downloading selected records:", selectedAllRecords);
      let res = await downloadSelectedDrn(selectedAllRecords, token);
    } catch (ex) {
      console.log(ex);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadAllDocs = async () => {
    try {
      setIsLoading(true);
      let filterPayload = {
        ...defaultFilters,
        ...(currentFilterParams || {}),
      };
      console.log("Downloading all tax documents with criteria:", filterPayload);
      let res = await downloadALLTaxDocs(filterPayload, token);
    } catch (ex) {
      console.log(ex);
    } finally {
      setIsLoading(false);
    }
  };

  // ============ API CALLS ============

  const fetchTaxCertificateData = async (filters: any, pageNum: number = 1) => {
    setTableLoading(true);

    const offset = ((pageNum - 1) * pageSize).toString();

    try {
      const res = await getTaxCertificateData(
        {
          offSet: offset,
          ...defaultFilters,
          ...(filters || {}),
        },
        token
      );

      console.log("Fetched Tax Certificate Data:", res);
      const counts = res?.body?.status?.countResult?.[0];
      let data = res?.body?.data || [];

      setTotalRecords(Number(counts?.total_order_number || 0));
      setTotalPendingRecords(Number(counts?.total_pending || 0));
      setTotalOverdueRecords(Number(counts?.total_overdue_pending || 0));
      setTotalValidRecords(Number(counts?.total_validated || 0));
      setTotalInValidRecords(Number(counts?.total_invalid || 0));
      setTotalExpiredRecords(Number(counts?.total_expired || 0));

      data = mapExpiredinStatus(data);

      setTaxCertificateData(data);
      setCurrentPage(pageNum);
      setSelectedRows({});
    } catch (error) {
      console.error("Error fetching tax certificate data:", error);
    } finally {
      setTableLoading(false);
    }
  };
  const mapExpiredinStatus = (data: any) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
  
    data.forEach((item: any) => {
      if (item.expiry_date) {
        const expiryDate = new Date(item.expiry_date);
        expiryDate.setHours(0, 0, 0, 0);
        
        if (expiryDate < currentDate && item.tax_tyepe==='PERIODICAL') {
          item.status = 'Expired';
        }
      }
      if (item.status === 'Invalid'){
        item.effective_date = null;
        item.expiry_date = null;
      }
      if(item.status === 'Valid'){
        item.invalid_reason = null;
      }
      if(item.validator_email){
        item.validator_email = item.validator_email.split('@')[0];
      }
    });
    
    return data;
  };


  const fetchAllRegionAndDocType = async () => {
    const res = await fetchRegionSearchVals(token);

    const sortedRegions = res?.region_data?.sort((a: any, b: any) =>
      a.region_name.localeCompare(b.region_name)
    );

    setRegionData(sortedRegions || []);
  };

  const fetchTaxFiterDetails = async () => {
    const res = await getTaxcFilerDetails(token);
    console.log("Fetched Tax Filer Details:", res);
    const filterData = {
      ...res?.body?.data,
      port_iso_code: res?.body?.port_iso_code,
      state_iso_code: res?.body?.state_iso_code
    };
    setTaxFilerDetails(filterData || null);
  };

  // const fetchTaxNotifications = async () => {
  //   const res = await getTaxNotification({ offSet: "0" }, token);
  //   console.log("Fetched Tax Notifications:", res);
  // };

  // ============ INITIAL LOAD ============

  useEffect(() => {
    const loadInitialData = async () => {
      if (!userEmail || hasFetched.current) return;

      hasFetched.current = true;
      setIsLoading(true);

      try {
        await Promise.all([
          fetchAllRegionAndDocType(),
          fetchTaxCertificateData(undefined, 1),
          fetchTaxFiterDetails(),
        ]);
      } catch (err) {
        console.error("Initial load error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialData();
  }, [userEmail]);

  // ============ EVENT HANDLERS ============

  const handleCardClick = (key: string) => {
    setSelectedStatus(key === selectedStatus ? null : key);

    if (key === "total") {
      setCurrentFilterParams(null);
      fetchTaxCertificateData(undefined, 1);
    } else {
      let finalkey =
        key === "validated"
          ? "Valid"
          : key === "invalid"
          ? "Invalid"
          : key === "pending"
          ? "Pending"
          : key === "overdue"
          ? "Overdue"
          : key === "expired"
          ? "Expire"
          : key;
      
      const filterToApply = {...currentFilterParams};
      if(Array.isArray(filterToApply.status)) filterToApply.status.push(finalkey);
      else filterToApply.status = [finalkey];
      setCurrentFilterParams(filterToApply);
      fetchTaxCertificateData(filterToApply, 1);
    }
  };

  const handleFilterApply = (filters: any) => {
    console.log("Applied Filters:", filters);

    const filterParams = {
      region_name: filters?.region?.length > 0 ? filters.region : [],
      status: filters?.status?.length > 0 ? filters.status : [],
      account_manager: filters?.account_manager?.length > 0 ? filters.account_manager : [],
      bussiness_channel: filters?.bussiness_channel?.length > 0 ? filters.bussiness_channel : [],
      country_name: filters?.country?.length > 0 ? filters.country : [],
      cust_code: filters?.cust_code?.length > 0 ? filters.cust_code : [],
      cust_name: filters?.cust_name?.length > 0 ? filters.cust_name : [],
      cust_sales_area: filters?.cust_sales_area?.length > 0 ? filters.cust_sales_area : [],
      order_number: filters?.order_number?.length > 0 ? filters.order_number : [],
      port_name: filters?.port?.length > 0 ? filters.port : [],
      sales_country: filters?.sales_country?.length > 0 ? filters.sales_country : [],
      tax_document_type: filters?.tax_document_type?.length > 0 ? filters.tax_document_type : [],
      vessel_imo_number: filters?.vessel_imo_number?.length > 0 ? filters.vessel_imo_number : [],
      vessel_name: filters?.vessel_name?.length > 0 ? filters.vessel_name : [],
    };

    setCurrentFilterParams(filterParams);
    fetchTaxCertificateData(filterParams, 1);
  };

  const handlePageChange = (pageNum: number) => {
    const totalPages = Math.ceil(totalRecords / pageSize);
    if (pageNum >= 1 && pageNum <= totalPages) {
      fetchTaxCertificateData(currentFilterParams, pageNum);
    }
  };

  const handleAddNewRecord = () => {
    setTriggerAddModal(true);
  };

  const handleModalClosed = () => {
    setTriggerAddModal(false);
  };

  // ============ MAIN UI ============

  return (
    <div className="tax-home-container">
      {/* Only render if taxFilerDetails is loaded */}
      {taxFilerDetails ? (
        <>
      {/* LEFT FILTER */}
      <div className="filter-section">
        <TaxFilter
          regionData={regionData}
          taxFilerDetails={taxFilerDetails}
          handleFilterApply={handleFilterApply}
        />
      </div>

      {/* RIGHT SIDE */}
      {taxCertificateData.length > 0 || tableLoading ? (
        <div className="right-section">
          {/* CARDS */}
         {totalRecords!==0&&(<div className="cards-container">
            {/* GROUP 1: Total Orders (Left) */}
            <div className="card-group-1">
              {cards.slice(0, 1).map((card) => (
                <div
                  key={card.key}
                  className={`status-card ${card.color} ${
                    selectedStatus === card.key ? "active" : ""
                  }`}
                  onClick={() => handleCardClick(card.key)}
                >
                  <div className="card-count">{card.count}</div>
                  <div className="card-label">{card.label}</div>
                </div>
              ))}
            </div>

            {/* GROUP 2: Pending + Overdue (Center) */}
            <div className="card-group-2">
              {cards.slice(1, 3).map((card) => (
                <div
                  key={card.key}
                  className={`status-card ${card.color} ${
                    selectedStatus === card.key ? "active" : ""
                  }`}
                  onClick={() => handleCardClick(card.key)}
                >
                  <div className="card-count">{card.count}</div>
                  <div className="card-label">{card.label}</div>
                </div>
              ))}
            </div>

            {/* GROUP 3: Invalid + Validated + Expired (Right) */}
            <div className="card-group-3">
              {cards.slice(3, 6).map((card) => (
                <div
                  key={card.key}
                  className={`status-card ${card.color} ${
                    selectedStatus === card.key ? "active" : ""
                  }`}
                  onClick={() => handleCardClick(card.key)}
                >
                  <div className="card-count">{card.count}</div>
                  <div className="card-label">{card.label==="Validated"?"Valid":card.label}</div>
                </div>
              ))}
            </div>
          </div>)}

          {/* Download All Modals */}
          <Modal
            isOpen={downloadALLmodal}
            toggle={downloadALLtoggle}
            backdrop="static"
            onClosed={() => {
              if (downloadALLAttenmodal === false) {
                setSelectedRows({});
              }
            }}
          >
            <ModalHeader toggle={downloadALLtoggle}>
              Confirm Download All
            </ModalHeader>
            <ModalBody>
              Please select <strong>Yes</strong> if you want to download all
              documents associated with current search criteria.
              <br />
              <br />
              Please select <strong>No</strong> if you want to download all
              documents of current page.
            </ModalBody>
            <ModalFooter>
              <Button
                level="secondary"
                rounded="pill"
                size="sm"
                theme="brand"
                className="clear-button1"
                onClick={() => {
                  downloadALLtoggle();
                  downloadAll();
                }}
              >
                No
              </Button>
              <Button
                level="primary"
                rounded="pill"
                size="sm"
                theme="brand"
                className="search-button1 mx-5"
                onClick={() => {
                  downloadALLtoggle();
                  setDownloadALLAttenmodal(true);
                }}
              >
                Yes
              </Button>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={downloadALLAttenmodal}
            toggle={downloadALLAttentoggle}
            backdrop="static"
            onClosed={() => {
              setSelectedRows({});
            }}
          >
            <ModalHeader toggle={downloadALLAttentoggle}>
              Attention
            </ModalHeader>
            <ModalBody>
              There is total number of <strong>{totalRecords}</strong>{" "}
              documents associated with current search criteria. Downloading
              all documents might take few minutes.
              <br />
              <br />
              Select <strong>Continue</strong> for download all else select{" "}
              <strong>Stop</strong> or <strong>Close</strong> this window to
              stop download all.
            </ModalBody>
            <ModalFooter>
              <Button
                level="secondary"
                rounded="pill"
                size="sm"
                theme="brand"
                className="clear-button1"
                onClick={() => {
                  downloadALLAttentoggle();
                  setSelectedRows({});
                }}
              >
                Stop
              </Button>
              <Button
                level="primary"
                rounded="pill"
                size="sm"
                theme="brand"
                className="search-button1 mx-5"
                onClick={() => {
                  downloadAllDocs();
                  setSelectedRows({});
                  downloadALLAttentoggle();
                }}
              >
                Continue
              </Button>
            </ModalFooter>
          </Modal>

         

          {/* TABLE WITH LOADING SPINNER */}
          
            {tableLoading ? 
            (
              <div className="table-loader">
                <Spinner color="brand" />
              </div>
            ) : 
            (<>
             {/* Download Button Badge - Only visible for tax_user and admin */}
          {(role === "tax_user" || role === "admin") && (
            <div className="download-button-container">
              <Button
                rounded="pill"
                theme="brand"
                level="primary"
                size="sm"
                disabled={selectedFlatRows.length <= 1}
                onClick={() => {
                  if (selectedFlatRows.length > 1) {
                    downloadAll();
                  }
                }}
                style={{ fontSize: "10px", backgroundColor: "lightgray" }}
              >
                <Download16 style={{ marginRight: "6px", width: "14px", height: "14px" }} />
                Download
                <div id="tax_download_tooltip">
                  <Info32 />
                </div>
              </Button>
              <div style={{ marginLeft: "8px", display: "flex", alignItems: "center" }}>
                <UncontrolledTooltip
                  autohide={false}
                  fade
                  flip
                  placement="bottom"
                  target="tax_download_tooltip"
                  popperClassName="ft-size"
                >
                  Download button will enable only on selection of two
                  documents or above
                </UncontrolledTooltip>
              </div>
            </div>
          )}
            <div className="table-container">
              <TaxCertificateTable
                rowData={taxCertificateData}
                setSelectedFlatRowsVals={setSelectedFlatRows}
                rowSelection={selectedRows}
                setRowSelection={setSelectedRows}
                triggerAddModal={triggerAddModal}
                onModalClosed={handleModalClosed}
                taxFilerDetails={taxFilerDetails}
              />
              </div>
          <div className="table-actions">
          <PaginationControls
            currentPage={currentPage}
            totalRecords={totalRecords}
            pageSize={pageSize}
            onPageChange={handlePageChange}
          />
         {(role==="admin" || role==='tax_user')&& <Button
            rounded="pill"
            theme="brand"
            level="primary"
            size="sm"
            onClick={handleAddNewRecord}
          >
            Create Record
          </Button>}
        </div>
        </>  )}
        </div>
      ) : (
        <div className="no-data-container">
          <h2 className="no-data-text">No records found.</h2>
        </div>
      )}</>):(
        <div className="table-loader">
          <Spinner color="brand" />
        </div>
      )}
      
    </div>
  );
}